import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=6cb861c9&scoped=true"
import script from "./clients.vue?vue&type=script&lang=js"
export * from "./clients.vue?vue&type=script&lang=js"
import style0 from "./clients.vue?vue&type=style&index=0&id=6cb861c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb861c9",
  null
  
)

export default component.exports